import AccordionText from "@/components/AccordionTextRefresh";
import type { ProcessedCourse } from "@/common/course/types";
import ProgramSummaryPathwayCourseItem from "./ProgramSummaryPathwayCourseItem";
import sortBySortValue from "@/utils/functions/sortBySortValue";
import useTranslations from "@/i18n/useTranslations";

interface ProgramSummaryPathwayProps {
  courses: ProcessedCourse[];
}

function ProgramSummaryPathway({ courses }: ProgramSummaryPathwayProps) {
  const t = useTranslations("Course");

  return (
    <div id="courses" className="flex flex-col gap-6">
      <h2 className="my-0 text-primary md:text-3xl font-bold">
        {t("coursesInThisProgramCount", { count: courses.length })}
      </h2>
      <AccordionText variant="pathway">
        {sortBySortValue(courses).map((course, index) => (
          <ProgramSummaryPathwayCourseItem
            key={course.productUuid}
            course={course}
            index={index}
          />
        ))}
      </AccordionText>
    </div>
  );
}

export default ProgramSummaryPathway;
